import { render, staticRenderFns } from "./hardClassStudentDialog.vue?vue&type=template&id=d5531a18"
import script from "./hardClassStudentDialog.vue?vue&type=script&lang=js"
export * from "./hardClassStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./hardClassStudentDialog.vue?vue&type=style&index=0&id=d5531a18&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports